module.exports = (theme) => ({
  ".message": {
    position: "relative",
    borderWidth: theme("borderWidth.DEFAULT"),
    borderColor: theme("colors.tertiary.lightergrey"),
    borderRadius: theme("borderRadius.sm"),
    fontSize: theme("fontSize.base"),
    fontFamily: theme("fontFamily.regular"),
    fontWeight: theme("fontWeight.regular"),
    lineHeight: theme("lineHeight.xs"),
    padding: theme("padding.DEFAULT"),
    marginTop: theme("margin.DEFAULT"),
    marginBottom: theme("margin.DEFAULT"),
  },
  ".message.icon": {
    paddingLeft: theme("width.4xl"),
  },
  ".message.icon::before": {
    position: "absolute",
    textAlign: "center",
    top: "0",
    left: "0",
    bottom: "0",
    lineHeight: theme("fontSize.6xl"),
    fontSize: theme("fontSize.6xl"),
    height: "100%",
    width: theme("width.4xl"),
    padding: theme("padding.DEFAULT"),
  },
});
